// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader_Loader__MZsIJ","center":"Loader_center__KEXDF"};